import styled from 'styled-components';
import css from '@styled-system/css';

import Box from 'humanity/primitives/box';
import Accordion from 'humanity/components/accordion';
import Heading from 'humanity/primitives/heading';
import { faqProps } from 'humanity/components/faq/faq.types';
import SimpleRichText from 'humanity/components/simpleRichText';

const FaqWrapper = styled(Box)(
  css({
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'backgroundLightGray2',
    pb: 3,
  })
);

const Faq = ({ index, title, content, ...props }) => (
  <FaqWrapper data-testid="Faq" {...props}>
    <Accordion baseId={`faq_${index}`} iconSize={32}>
      <Heading
        p={1}
        variant={['h6', null, 'h5']}
        dangerouslySetInnerHTML={{ __html: title?.trim() }}
      />
      <Box pt={3}>
        <SimpleRichText content={content?.json} />
      </Box>
    </Accordion>
  </FaqWrapper>
);

Faq.propTypes = {
  ...faqProps,
};

export default Faq;
